import React from 'react';

import { Button, Dropdown, Popconfirm, Tag } from 'antd';

import { DeleteOutlined, EditOutlined, MoreOutlined } from '@ant-design/icons';

import { FieldSummary } from '../../../models/FieldsSummary';

interface Props {
    field: FieldSummary;
    onOpen: () => void;
    onEdit: () => void;
    onDelete: () => void;
    onOpenSeason: () => void;
}

const STATUS_META: Record<string, { color: string; label: string }> = {
    ok: { color: 'green', label: 'норма' },
    warn: { color: 'orange', label: 'внимание' },
    none: { color: 'default', label: 'нет данных' },
};

const FieldCard = (props: Props) => {
    const { field, onOpen, onEdit, onDelete, onOpenSeason } = props;

    const status = STATUS_META[field.status] || STATUS_META.none;

    const prod = field.latest?.productive;
    const mmList = prod?.mm || [];
    const depths = prod?.depths_cm || [];

    const rain = field.rain_24h;
    const rainSource =
        rain?.source === 'station' ? 'станция' : rain?.source === 'open-meteo' ? 'Open-Meteo' : '';

    const menuItems = [
        { key: 'edit', icon: <EditOutlined />, label: 'Изменить', onClick: onEdit },
        { key: 'season', label: 'Сезон', onClick: onOpenSeason },
        { type: 'divider' as const },
        {
            key: 'delete',
            danger: true,
            icon: <DeleteOutlined />,
            label: (
                <Popconfirm title="Удалить поле?" okText="Да" cancelText="Нет" onConfirm={onDelete}>
                    <span>Удалить</span>
                </Popconfirm>
            ),
        },
    ];

    return (
        <div className="field-card">
            <div className="field-card-head">
                <div className="field-card-title">{field.name || `Поле №${field.id}`}</div>
                <Tag color={status.color} style={{ margin: 0 }}>
                    {status.label}
                </Tag>
            </div>

            <div className="field-card-row">
                <span className="field-card-label">Площадь</span>
                <span>{field.area_ga ? `${field.area_ga.toFixed(1)} га` : '—'}</span>
            </div>
            <div className="field-card-row">
                <span className="field-card-label">Культура</span>
                <span>{field.season?.culture_name || '—'}</span>
            </div>
            <div className="field-card-row">
                <span className="field-card-label">Фаза</span>
                <span>{field.season?.current_phase || '—'}</span>
            </div>

            <div className="field-card-divider" />

            <div className="field-card-row">
                <span className="field-card-label">Влага</span>
                <span>
                    {mmList.length === 0
                        ? '—'
                        : mmList
                              .map((mm, i) => `${depths[i] ?? '?'} см: ${mm.toFixed(0)} мм`)
                              .join(' · ')}
                </span>
            </div>
            <div className="field-card-row">
                <span className="field-card-label">Осадки 24 ч</span>
                <span>
                    {rain ? `${rain.value.toFixed(1)} мм` : '—'}
                    {rainSource ? <span className="field-card-muted"> · {rainSource}</span> : null}
                </span>
            </div>

            <div className="field-card-footer">
                <Button type="primary" size="small" onClick={onOpen}>
                    Открыть
                </Button>
                <Dropdown menu={{ items: menuItems }} trigger={['click']}>
                    <Button size="small" icon={<MoreOutlined />}>
                        Ещё
                    </Button>
                </Dropdown>
            </div>
        </div>
    );
};

export default FieldCard;
